import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.bgColor};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.metrics.radius.medium};
  overflow: hidden;
  transition: all 0.3s;
  color: inherit;

  &:hover {
    box-shadow: 0 4px 16px ${({ theme }) => theme.colors.shadow};
    transform: translateY(-4px);
    color: inherit;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 240px;
  background: ${({ theme }) => theme.colors.bgSecondary};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export const FavoriteButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: white;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  color: ${({ theme }) => theme.colors.accent.main};
  transition: all 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.accent.dark};
    background: ${({ theme }) => theme.colors.accent.light};
  }
`;

export const CardBody = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
`;

export const BookTitle = styled.h3`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.md};
  color: ${({ theme }) => theme.colors.text.dark.very};
  font-weight: 700;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const AuthorName = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

export const CardFooter = styled.div`
  padding: 0 16px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const AddToCartBtn = styled.button`
  background: ${({ theme }) => theme.colors.secondary.main};
  color: ${({ theme }) => theme.colors.primary.dark};
  border: none;
  padding: 8px 16px;
  border-radius: ${({ theme }) => theme.metrics.radius.small};
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  font-weight: 600;
  transition: background 0.2s;

  &:hover {
    background: ${({ theme }) => theme.colors.secondary.dark};
  }
`;
